import React from 'react';

import t from '../../../labels/labelling-utils';
import { StatisticsId } from '../../../typings/statistics';
import { getNumber } from '../../../utils/numbers';
import { makeClassNames } from '../../../utils/styles';
import Text from '../../atoms/text/text';
import MatchStatisticsRow from '../../molecules/match-statistics-row/match-statistics-row';

import './match-statistics-table.scss';

export interface IMatchStatisticsValue {
  home?: string | null;
  away?: string | null;
}
export interface IMatchStatistics {
  id: StatisticsId;
  value: IMatchStatisticsValue;
}
export interface IMatchStatisticsTable {
  matchStatisticsList: IMatchStatistics[];
}

const classNames = () =>
  makeClassNames({
    MatchStatisticsTable: 'match-statistics-table',
    MatchStatisticsTableHead: 'match-statistics-table__head',
    MatchStatisticsTableHeadRow: 'match-statistics-table__head-row',
    MatchStatisticsTableHeadText: 'match-statistics-table__head-title-text',
    MatchStatisticsTableBody: 'match-statistics-table__body',
  });

const MatchStatisticsTable = ({ matchStatisticsList }: IMatchStatisticsTable) => {
  const cn = classNames();

  return (
    <table className={cn.MatchStatisticsTable}>
      <thead className={cn.MatchStatisticsTableHead}>
        <tr className={cn.MatchStatisticsTableHeadRow}>
          <th>
            <Text className={cn.MatchStatisticsTableHeadText} color="dark" fontSize="16" fontWeight="500">
              {t('match.statistics.title')}
            </Text>
          </th>
        </tr>
      </thead>
      <tbody className={cn.MatchStatisticsTableBody}>
        {matchStatisticsList.map((matchStatistics: IMatchStatistics) => {
          const { home, away } = matchStatistics.value;

          return (
            <React.Fragment key={matchStatistics.id}>
              <MatchStatisticsRow
                label={matchStatistics.id}
                homeNumber={getNumber(home)}
                awayNumber={getNumber(away)}
              />
            </React.Fragment>
          );
        })}
      </tbody>
    </table>
  );
};

export default MatchStatisticsTable;
